module.exports = __webpack_public_path__ + "static/brownteddyjacket-52fbcc5d8c8f1ee327e7f0b52e82ac35.jpeg";